import axiosInstance from "@/api/axiosInstance";
import { SharedWithMeKeyResponse } from "./types";

export const getSharedWithMeKey =
  async (): Promise<SharedWithMeKeyResponse> => {
    const response = await axiosInstance.get<SharedWithMeKeyResponse>(
      "/api/search/shared-with-me-key",
    );
    return response.data;
  };
